module.exports = __webpack_public_path__ + "static/media/texture (32).30ee2dd0.jpg";